module.exports = __webpack_public_path__ + "img/fazhan.46dea1c8.png";